import { createSelector } from "@reduxjs/toolkit";
import { convertArrayToObject } from "utils/common-util";
import { MasterSelector } from ".";

export const AddressSelector = {
  addressCache: (state) => MasterSelector.state(state).address,
  provincesLoading: (state) => AddressSelector.addressCache(state).provinceOption.loading,
  provinces: (state) => AddressSelector.addressCache(state).provinceOption.options,
  provinceOption: createSelector(
    [(state) => AddressSelector.provinces(state)],
    (provinces) =>
      provinces.map((province) => ({
        label: province.provinceName,
        value: province.provinceCode,
      }))
  ),
  districtCache: (state) => AddressSelector.addressCache(state).districtOption,
  districtSelector: () => createSelector(
    [
      (state, provinceCode) =>
        AddressSelector.districtCache(state)[provinceCode]
    ],
    (districtCache) => {
      if (!districtCache) {
        return { loading: true, options: [] }
      }
      return {
        loading: districtCache.loading,
        options: districtCache.options.map((district) => ({
          label: district.districtName,
          value: district.districtCode,
        })),
        mapper: convertArrayToObject(districtCache.options, 'districtCode'),
      }
    }
  ),
  subDistrictCache: (state) => AddressSelector.addressCache(state).subDistrictOption,
  subDistrictSelector: () => createSelector(
    [
      (state, provinceCode, districtCode) =>
        AddressSelector.subDistrictCache(state)[`${provinceCode}_${districtCode}`]
    ],
    (subDistrictCache) => {
      if (!subDistrictCache) {
        return { loading: true, options: [] }
      }
      return {
        loading: subDistrictCache.loading,
        options: subDistrictCache.options.map((subDistrict) => ({
          label: subDistrict.subDistrictName,
          value: subDistrict.subDistrictCode,
        })),
        mapper: convertArrayToObject(subDistrictCache.options, 'subDistrictCode'),
      }
    }
  ),
};